<template>
  <div id="marche_content_vendus" class="container mt-3">
    <div
      class="row bg-blue bigText evalBlock mb-3"
      v-if="rights.rapport.marche_immo_bien_vendus_stats_transactions"
    >
      <div class="col-md-12 evalTitle">
        <h3>{{ $t("Statistiques des") }} {{ $t("transactions") }}</h3>
      </div>
      <div class="col-md-4 statB br bb">
        <b
          >{{ $t("appartements vendus") }}
          <span
            v-if="
              value.marche_vendus_annee >= 2021 &&
                value.version != '5' &&
                value.version != 'v5' &&
                value.version != '7' &&
                value.version != 'v7' &&
                value.version != '9' &&
                value.version != 'v9' &&
                value.version != '11' &&
                value.version != 'v11'
            "
            >au 1er semestre</span
          ><span v-else>en</span> {{ value.marche_vendus_annee }}</b
        >
        <h2 class="bold">
          <span v-if="value.marche_vendus_appartements !== null">{{
            format_number(value.marche_vendus_appartements)
          }}</span
          ><span v-else class="small">{{ nodata }}</span>
        </h2>
        <p></p>
      </div>
      <div class="col-md-4 statB br bb">
        <b>{{ $t("prix moyen des appartements vendus") }}</b>
        <h2 class="bold">
          <span v-if="value.marche_vendus_px_moy_appartements !== null"
            >{{ $t("$") }}
            {{ format_number(value.marche_vendus_px_moy_appartements) }}
            {{ $t("€") }}</span
          ><span v-else class="small">{{ nodata }}</span>
        </h2>
        <p>
          <small v-if="value.marche_vendus_px_moy_appartements_m2 !== null"
            >{{ $t("$") }}
            {{ format_number(value.marche_vendus_px_moy_appartements_m2) }}
            {{ $t("€") }}/m²</small
          >
        </p>
      </div>
      <div class="col-md-4 statB bb">
        <b>{{ $t("superficie moyenne") }}</b>
        <h2 class="bold">
          <span v-if="value.marche_vendus_s_moy_appartements_m2 !== null"
            >{{
              format_number(value.marche_vendus_s_moy_appartements_m2)
            }}
            m²</span
          ><span v-else class="small">{{ nodata }}</span>
        </h2>
        <p></p>
      </div>
      <div class="col-md-4 statB br ">
        <b
          >{{ $t("Maisons vendues") }}
          <span
            v-if="
              value.marche_vendus_annee >= 2021 &&
                value.version != '5' &&
                value.version != 'v5' &&
                value.version != '7' &&
                value.version != 'v7' &&
                value.version != '9' &&
                value.version != 'v9' &&
                value.version != '11' &&
                value.version != 'v11'
            "
            >au 1er semestre</span
          ><span v-else>en</span> {{ value.marche_vendus_annee }}</b
        >
        <h2 class="bold">
          <span v-if="value.marche_vendus_maisons !== null">{{
            format_number(value.marche_vendus_maisons)
          }}</span
          ><span v-else class="small">{{ nodata }}</span>
        </h2>
        <p></p>
      </div>
      <div class="col-md-4 statB br">
        <b>{{ $t("prix moyen des maisons vendues") }}</b>
        <h2 class="bold">
          <span v-if="value.marche_vendus_px_moy_maisons !== null"
            >{{ $t("$") }}
            {{ format_number(value.marche_vendus_px_moy_maisons) }}
            {{ $t("€") }}</span
          ><span v-else class="small">{{ nodata }}</span>
        </h2>
        <p>
          <small v-if="value.marche_vendus_px_moy_maisons_m2 !== null"
            >{{ $t("$") }}
            {{ format_number(value.marche_vendus_px_moy_maisons_m2) }}
            {{ $t("€") }}/m²</small
          >
        </p>
      </div>
      <div class="col-md-4 statB">
        <b>{{ $t("superficie moyenne") }}</b>
        <h2 class="bold">
          <span v-if="value.marche_vendus_s_moy_maisons_m2 !== null"
            >{{ format_number(value.marche_vendus_s_moy_maisons_m2) }} m²</span
          ><span v-else class="small">{{ nodata }}</span>
        </h2>
        <p></p>
      </div>
    </div>
    <div
      class="row bg-blue bigText evalBlock mb-3"
      v-if="rights.rapport.marche_immo_bien_vendus_carte_transactions"
    >
      <div class="col-md-6 evalTitle">
        <h3>{{ $t("Carte des") }} {{ $t("transactions") }}</h3>
      </div>
      <div class="col-md-6 text-right"></div>
      <div class="col-md-12">
        <div
          class="embed-responsive embed-responsive-16by9"
          v-if="rights.rapport.marche_immo_bien_vendus_stats_transactions"
        >
          <iframe
            :src="
              ooftopMapApi +
                'map-dvf?com_insee=' +
                value.code_insee +
                '&point=' +
                value.lat +
                ',' +
                value.lng +
                '&interactive=1&_api_key=' +
                ooftopMapApiKey +
                '&lang=' +
                $i18n.locale
            "
            class="embed-responsive-item"
          ></iframe>
        </div>
      </div>
    </div>
    <div
      class="row bg-blue bigText evalBlock mb-3"
      v-if="rights.rapport.marche_immo_bien_vendus_evolution_prix"
    >
      <div class="col-md-12 evalTitle">
        <h3>{{ $t("Evolution des prix") }}</h3>
      </div>
      <div class="col-md-12">
        <div
          class="embed-responsive embed-responsive-16by9"
          v-if="rights.rapport.marche_immo_bien_vendus_evolution_prix"
        >
          <iframe
            :src="
              ooftopMapApi +
                'export-api/render-chart?com_insee=' +
                value.code_insee +
                '&city_indicators=communes_dvf-prix-moyen_vente&freshness=P10Y&chart_type=dvf_commune_evolution_prix_vente&_api_key=' +
                ooftopMapApiKey +
                '&lang=' +
                $i18n.locale
            "
            class="embed-responsive-item"
          ></iframe>
        </div>
      </div>
    </div>
    <div
      class="row"
      v-if="rights.rapport.marche_immo_bien_vendus_repartition_biens"
    >
      <div class="col-6 pr-4">
        <div class="row bg-blue bigText evalBlock mb-3">
          <div class="col-md-12 evalTitle">
            <h3>{{ $t("Répartition des biens par prix") }}</h3>
          </div>
          <div class="col-md-12">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                :src="
                  ooftopMapApi +
                    'dvf/distribution-plot?com_insee=' +
                    value.code_insee +
                    '&type=prix&_api_key=' +
                    ooftopMapApiKey +
                    '&lang=' +
                    $i18n.locale
                "
                class="embed-responsive-item"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 pl-4">
        <div class="row bg-blue bigText evalBlock mb-3">
          <div class="col-md-12 evalTitle">
            <h3>{{ $t("Répartition des biens par superficie") }}</h3>
          </div>
          <div class="col-md-12">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                :src="
                  ooftopMapApi +
                    'dvf/distribution-plot?com_insee=' +
                    value.code_insee +
                    '&type=surface&_api_key=' +
                    ooftopMapApiKey +
                    '&lang=' +
                    $i18n.locale
                "
                class="embed-responsive-item"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 pr-4">
        <div class="row bg-blue bigText evalBlock mb-3">
          <div class="col-md-12 evalTitle">
            <h3>{{ $t("Répartition des biens par nombre de pièces") }}</h3>
          </div>
          <div class="col-md-12">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                :src="
                  ooftopMapApi +
                    'dvf/distribution-plot?com_insee=' +
                    value.code_insee +
                    '&type=pieces&_api_key=' +
                    ooftopMapApiKey +
                    '&lang=' +
                    $i18n.locale
                "
                class="embed-responsive-item"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 pl-4">
        <div class="row bg-blue bigText evalBlock mb-3">
          <div class="col-md-12 evalTitle">
            <h3>{{ $t("Répartition des biens par typologie") }}</h3>
          </div>
          <div class="col-md-12">
            <div class="embed-responsive embed-responsive-16by9">
              <iframe
                :src="
                  ooftopMapApi +
                    'dvf/distribution-plot?com_insee=' +
                    value.code_insee +
                    '&type=type_local&_api_key=' +
                    ooftopMapApiKey +
                    '&lang=' +
                    $i18n.locale
                "
                class="embed-responsive-item"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row bg-blue bigText evalBlock mb-3"
      v-if="rights.rapport.marche_immo_bien_vendus_comparatif_local"
    >
      <div class="col-md-12 evalTitle">
        <h3>{{ $t("Comparatif local") }}</h3>
      </div>
      <div class="col-md-12">
        <div class="embed-responsive embed-responsive-16by9">
          <iframe
            :src="
              ooftopMapApi +
                'map-indicator?map_id=dvfs&com_insee=' +
                value.code_insee +
                '&type=type_local&_api_key=' +
                ooftopMapApiKey +
                '&lang=' +
                $i18n.locale
            "
            class="embed-responsive-item"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EvaluationTransactions",
  components: {},
  data() {
    return {
      nodata: this.$i18n.t("Données insuffisantes"),
      openRC: 0,
      forms: {},
    };
  },
  props: {
    value: Object,
    rights: Object,
    ooftopMapApiKey: String,
    ooftopMapApi: String,
  },
};
</script>
